module.exports = __webpack_public_path__ + "img/s1.5e5513a8.jpg";